module.exports = __webpack_public_path__ + "img/ar.ae203093.png";